export default __webpack_public_path__ + "static/media/cloud_icon_01.ce64f35c.svg";